import { render, staticRenderFns } from "./Screen4.vue?vue&type=template&id=9a734524&scoped=true&lang=html&"
import script from "./Screen4.vue?vue&type=script&lang=js&"
export * from "./Screen4.vue?vue&type=script&lang=js&"
import style0 from "./Screen4.vue?vue&type=style&index=0&id=9a734524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a734524",
  null
  
)

export default component.exports